<template>
  <div>
    <div class="massBalanceTitle">
      {{ $t('massBalance.pageName') }}
    </div>
    <div class="massBalanceDevicesWrapper">
      <CoolingTowerComponent />
      <BoilerComponent />
      <Simplified />
    </div>
  </div>
</template>

<script>
import CoolingTowerComponent from '@/views/sites/massBalance/coolingTower/CoolingTowerComponent.vue';
import BoilerComponent from '@/views/sites/massBalance/boiler/BoilerComponent.vue';
import Simplified from '@/views/sites/massBalance/simplified/index.vue';

export default {
    components: {
        BoilerComponent,
        CoolingTowerComponent,
        Simplified,
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/massBalanceStyle.scss";
</style>
